import { Pressable } from "react-native";
import { Stack, useRouter } from "expo-router";
import { ChevronBackIcon } from "@/components/Icons";
import { colors } from "@/lib/theme";

function BackButton() {
  const router = useRouter();
  return (
    <Pressable onPress={() => router.back()}>
      <ChevronBackIcon size={24} color={colors.ink} />
    </Pressable>
  );
}

const signupScreen = {
  headerShown: true,
  headerTitle: "",
  headerLeft: () => <BackButton />,
  headerShadowVisible: false,
  headerStyle: { backgroundColor: colors.white },
} as const;

export default function AuthLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="welcome" />
      <Stack.Screen name="login" />
      <Stack.Screen name="signup-club" options={signupScreen} />
      <Stack.Screen name="signup-account" options={signupScreen} />
    </Stack>
  );
}
